import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import React from 'react';
import { ButtonBase } from '../../Button/ButtonBase/index.js';

var InputIconButton = React.forwardRef(function (_a, ref) {
    var children = _a.children, disabled = _a.disabled, title = _a.title, onClick = _a.onClick, onKeyPress = _a.onKeyPress, props = __rest(_a, ["children", "disabled", "title", "onClick", "onKeyPress"]);
    return (jsx(ButtonBase, __assign({}, props, { themeKey: "iconButtons", ref: ref, disabled: disabled, title: title, type: "button", sx: {
            color: "black.60",
            "--icon-size": "16px",
            "--button-size": "26px",
        }, look: "naked", tone: "secondary", tabIndex: 0, onKeyPress: onKeyPress, onClick: onClick }, { children: children })));
});
InputIconButton.displayName = "InputIconButton";

export { InputIconButton };
//# sourceMappingURL=InputIconButton.js.map
